import { render, staticRenderFns } from "./LangSelect.vue?vue&type=template&id=8ec1b724&scoped=true&"
import script from "./LangSelect.vue?vue&type=script&lang=js&"
export * from "./LangSelect.vue?vue&type=script&lang=js&"
import style0 from "./LangSelect.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LangSelect.vue?vue&type=style&index=1&id=8ec1b724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec1b724",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/procure-web-seven-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ec1b724')) {
      api.createRecord('8ec1b724', component.options)
    } else {
      api.reload('8ec1b724', component.options)
    }
    module.hot.accept("./LangSelect.vue?vue&type=template&id=8ec1b724&scoped=true&", function () {
      api.rerender('8ec1b724', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LangSelect.vue"
export default component.exports